import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import CusInput from '../../../../../components/material-ui/CusInput';
import useNumberParams from '../../../../../hooks/useNumberParams';
import useToast from '../../../../../hooks/useToast';
import { API_CASINO } from '../../../../../api/casino';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import CodeEditor from '../../../../../components/material-ui/code_editor/CodeEditor';
import { useDispatch } from 'react-redux';
import { setCasinoActionsConfig } from '../../../../../store/apps/userSlice';
import { useAppSelector } from '../../../../../store';

export default function GatewayContent() {
  const dispatch = useDispatch();
  const casinoId = useNumberParams('casinoId');
  const { successToast } = useToast();
  const enabledBtn = useAppSelector((state) => state.user.casinoActions.config);

  const [textConfig, setTextConfig] = useState('');

  useEffect(() => {
    API_CASINO.config
      .get({ casinoId, config: 'crypto' })
      .then((e) => {
        const data = e.data.data;
        setTextConfig(data.crypto);
        dispatch(setCasinoActionsConfig(data.editable));
      })
      .catch(console.error);
  }, [casinoId]);

  const onSaveClick = () => {
    API_CASINO.config
      .set({ casinoId, data: { crypto: textConfig } })
      .then((e) => {
        successToast('Successfully updated');
      })
      .catch(console.error);
  };

  return (
    <Stack display={'flex'} direction={'column'} gap={1}>
      {/* <CusSwitch label={'Enabled'} /> */}

      <CodeEditor text={textConfig} setText={setTextConfig} readOnly={!enabledBtn} />

      <CasinoBtnSave onClick={onSaveClick} disabled={!enabledBtn} />
    </Stack>
  );
}
